import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class SigtripStaffsTrainings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    
    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/treinamentos/pendentes/associados', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'redirect') {
            var url = '/pendencias/treinamento/sigmec';
            self.setState({redirect_url: url});
        } else {
            self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
      
      var botao = "";
      
      if(row.confirmation_token_presence && row.confirmation_token_absence) {
          var confirmation_token_presence_url = 'http://' + row.confirmation_url + '/email/confirmacao/' + row.confirmation_token_presence;
          var confirmation_token_absence_url = 'http://' + row.confirmation_url + '/email/confirmacao/' + row.confirmation_token_absence;
        botao = (
          <div className="btn-group">
            <a className={'btn btn-success btn-sm button-inline'} target="_blank" href={confirmation_token_presence_url}>
              <i className="fa fa-fw fa-check"></i> {this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.botaoConfirmarPresenca}
            </a>
            <a className={'btn btn-danger btn-sm button-inline'} target="_blank" href={confirmation_token_absence_url}>
              <i className="fa fa-fw fa-close"></i> {this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.botaoConfirmarAusencia}
            </a>
          </div>
        );
    }

    return botao;
  }

  render() {
    return (
<div>
    {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
        <h3 className="page-title">{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.titulo}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.semTreinamentos}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='450'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Nome}</TableHeaderColumn>
        <TableHeaderColumn dataField="status_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Status}</TableHeaderColumn>
        <TableHeaderColumn dataField="code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='140'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.CodigoDeControle}</TableHeaderColumn>
        <TableHeaderColumn dataField="certification_types" dataAlign="center" filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} dataFormat={this.CertificationsTypesTable} width='140'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.TiposDeCertificado}</TableHeaderColumn>
        <TableHeaderColumn dataField="presence_types" dataAlign="center" filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} dataFormat={this.PresenceTypesTable} width='120'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Modalidade}</TableHeaderColumn>
        <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.DataInicial}</TableHeaderColumn>
        <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.DataFinal}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='280'>{this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default SigtripStaffsTrainings;



// WEBPACK FOOTER //
// ./src/Components/SigtripStaffs/SigtripStaffsPendingTrainings.js